import { AxiosError, AxiosResponse } from 'axios'
import { axiosInstance } from '../../config/axios.config'
export interface IPropsLoginPage {
  props?: object
}
export interface IAuthLogin {
  email: string
  password: string
  confirm_password?: string
}

export interface IAuthCreateSuccessResponse {
  status: string
  token: string
  id: number
}

export interface IAuthCreateErrorResponse {
  status: string
  error: string
}

export function authLogin(
  url: string,
  payload: IAuthLogin,
  callback?: (
    result:
      | AxiosResponse<IAuthCreateSuccessResponse>
      | AxiosError<IAuthCreateErrorResponse>
  ) => void
): void {
  axiosInstance
    .post<IAuthCreateSuccessResponse>(url, payload)
    .then((response) => {
      callback?.(response)
    })
    .catch((error: unknown) => {
      if (error instanceof AxiosError) {
        callback?.(error)
      }
    })
}
